import React from "react";
import Seo from "../components/Seo";
import Loading from "../components/Loading";
import {Link} from "react-router-dom";
import "../css/Documentation.css";
import {BrokerBenchmark, parseBrokerResult} from "../components/BrokerBenchmark";
import fanInUrl from "../xmq_test_results/Fan-In.txt";

export default class XMQ_tests_fanin extends React.Component
{
    state = {servers: null, error: null};

    componentDidMount()
    {
        fetch(fanInUrl)
            .then((r) => r.text())
            .then((text) => this.setState({servers: parseBrokerResult(text)}))
            .catch((err) => this.setState({error: String(err)}));
    }

    render()
    {
        const {servers, error} = this.state;
        return <div key="tests-fanin" className="XMQ" style={{textAlign: "left", padding: 8}}>
            <Seo title="MQTT Performance Tests — Fan-In"
                 description="MQTT fan-in benchmark for telemetry ingestion: 50,000 publishers feed 500 shared subscribers at QoS 1."
                 keywords="MQTT performance tests, fast MQTT server, MQTT benchmark, XMQ"
                 path="/xmq_tests_fanin"/>
            <h1>MQTT Performance Tests: Fan-In</h1>
            <h3>Fan-In: Telemetry Ingestion</h3>

            <p>
                Models a telemetry stream from 50,000 publishers, each sending one QoS&nbsp;1
                message per second. A shared group of 500 subscribers divides the 50,000
                messages/second between its members, so each publication is delivered once. See
                the <Link to="/xmq_tests_environment">Test Environment</Link> page for hardware
                and test method.
            </p>

            <p>
                XMQ 1.0.2 and FlashMQ 1.27.2 were re-measured on 2 November 2026 on the same
                c5n.4xlarge host (16 vCPU, 40 GB) as the other brokers here. Percentiles are
                shown where the run recorded them; a dash means its result file has no percentile
                section.
            </p>

            {error && <p>Failed to load test results: {error}</p>}
            {!servers && !error && <Loading text="Loading results…"/>}

            <BrokerBenchmark servers={servers} targetRate={50000}/>

        </div>;
    }
}
